import {
    LegacyClipPlayerBaseInfoContent,
    MovieOnlineStreamsFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';
import { PreferredTracks, Source } from '@/scenarios/legacy-player/types/config';

import type { PlayerFeatureFlags } from '../../../../lib/featureFlags';
import { transformGqlDrmToPlayerDrm } from '../../../movie-player/transformers/transform-drm';

import { transfromAudio } from './transform-audio';
import { transformSubtitles } from './transform-subtitles';
import { getPuidAndFrom } from './get-puid-and-from';

interface Props {
    contentId: string;
    onlineStreams:
        | MovieOnlineStreamsFragment
        | LegacyClipPlayerBaseInfoContent['onlineStreams']
        | undefined;
    startPosition?: number;
    telemetry: {
        from_block: string;
        stream_block: string;
    };
    preferredTracks: PreferredTracks;
    fetchSubtitles?: boolean;
}

interface Dependencies {
    profileManager: ProfileManager;
    featureFlags: PlayerFeatureFlags;
}

export const getOnlineStreamsConfig: (props: Props, deps: Dependencies) => Source[] = (
    { onlineStreams, contentId, startPosition, telemetry, preferredTracks, fetchSubtitles },
    { profileManager, featureFlags }
) => {
    const forcedStreamUri = featureFlags.flags.get('forcedStreamUri');
    const sources: Source[] = [
        {
            id: contentId,
            streams: onlineStreams?.streams
                ? onlineStreams.streams.map((stream) => ({
                      url: forcedStreamUri === '' && stream?.uri ? stream.uri : forcedStreamUri,
                      audio: transfromAudio(stream?.streamMeta?.audioMetas),
                      drmConfig: transformGqlDrmToPlayerDrm(stream?.streamMeta?.drmConfig),
                      subtitles: fetchSubtitles
                          ? undefined
                          : transformSubtitles(stream?.streamMeta?.subtitleMetas),
                  }))
                : [],
            startPosition,
            additionalParams: {
                ...getPuidAndFrom({ profileManager }),
                ...telemetry,
            },
            userPreferences: {
                preferredTracks,
            },
            fetchSubtitles,
        },
    ];

    return sources;
};
